import { render, staticRenderFns } from "./UpdateUserButton.vue?vue&type=template&id=07b55308&"
import script from "./UpdateUserButton.vue?vue&type=script&lang=js&"
export * from "./UpdateUserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports